import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import AlertBox from "./AlertBox";
import { getPublicS3Url } from "../utils/s3Utils";

function SuccessProcess() {
  const location = useLocation();
  const { labelUrl } = location.state || {};
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");

  const handleDownloadLabel = () => {
    if (labelUrl) {
      try {
        const url = new URL(labelUrl);
        const s3Key = url.pathname.substring(1);
        const publicUrl = getPublicS3Url(
          process.env.REACT_APP_S3_BUCKET_NAME,
          s3Key
        );
        console.log(publicUrl);
        window.open(publicUrl, "_blank");
      } catch (error) {
        console.error("Error:", error);
        setMessageAlert("Ocurrió un error al descargar la etiqueta");
        setOpenErrorAlert(true);
      }
    } else {
      setMessageAlert("Ocurrió un error al descargar la etiqueta");
      setOpenErrorAlert(true);
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <h1>Preparación de Pedidos</h1>
      </Grid>
      <Grid container>
        <Grid item xs={12} className="flex-center">
          <Grid container className="request-success-main-container">
            <Grid item xs={12} className="flex-center">
              <span className="confeti-icon large-icon">🎉</span>
            </Grid>
            <Grid item xs={12} className="flex-center">
              <h4 className="fw-medium">¡Órden procesada exitósamente!</h4>
            </Grid>
            <Grid item xs={12} className="flex-center">
              <p>
                Procesaste la órden con éxito, ahora puedes tomarte un café,
                procesar otra órden, o descargar la etiqueta del envío.
              </p>
            </Grid>
            <Grid item xs={12} sm={12} className="success-buttons-container">
              <Link to="/home/orders" className="back-login-btn">
                <Button type="submit" variant="outlined">
                  {"Órdenes"}
                </Button>
              </Link>
              <Link to="/home/pending-orders" className="back-login-btn">
                <Button type="submit" variant="outlined">
                  {"Preparación de Pedidos"}
                </Button>
              </Link>
            </Grid>
            <Grid item xs={12} sm={12} className="success-buttons-container">
              <Button
                type="submit"
                variant="contained"
                onClick={handleDownloadLabel}
              >
                {"Descargar Etiqueta"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <AlertBox
        severity="error"
        messageAlert={messageAlert}
        setOpenAlert={setOpenErrorAlert}
        openAlert={openErrorAlert}
        hideDuration={6000}
      />
    </>
  );
}

export default SuccessProcess;
